import Display from './Display';
import List from './List';
import Mini from './Mini';
import NewDefault from './NewDefault';

const EventCard = { Default: NewDefault, Display, Mini, List };

export default EventCard;
